module.exports = __webpack_public_path__ + "fonts/Manrope-800-vietnamese28.d255f9e.woff2";